// Single source of truth for "last genuine user activity" (DOM-driven only).
// Background/automated calls never touch this, so the server-side inactivity
// window cannot be extended by them: refresh calls read isRecentlyActive() to
// decide whether to advance the server's last-activity marker.
export const ACTIVITY_WINDOW_MS = 14 * 60 * 1000; // > proactive refresh (12 min)

let _last = Date.now();

export function markActivity() {
  _last = Date.now();
}

export function lastActivity() {
  return _last;
}

export function isRecentlyActive(windowMs = ACTIVITY_WINDOW_MS) {
  return Date.now() - _last < windowMs;
}
